import React from "react";
import withLocalization from "../../../hoc/with-localization";
import "./spinner.scss";
const Spinner = ({ loc, captionText }) => (
    <div className="spinner">
        <h3 className="state-indicator__header">{captionText || loc("loading")}</h3>
        <div className="state-indicator__indicator-wrapper">
            <div className="spinner__rounding"></div>
        </div>
    </div>
);

export default withLocalization(Spinner);
